import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';

import Avatar from 'components/Avatar';

import IconAttachmentFiles from 'icons/AttachmentFiles';

import ItemCard from 'styled/ItemCard/Card';
import Name from 'styled/ItemCard/Name';
import Info from 'styled/ItemCard/Info';
import CardFooter from 'styled/ItemCard/CardFooter';

import BanWrapper from './BanWrapper';

export class User extends React.PureComponent {
  render() {
    return (
      <NavLink style={{ textDecoration: 'none' }} to={`/users/${this.props.id}`}>
        <ItemCard style={{ paddingBottom: '16px' }}>
          <BanWrapper isBanned={this.props.isBanned}>
            <Avatar
              name={this.props.name}
              fontSize="24px"
              url={this.props.avatar}
            />

            <CardFooter>
              <Info style={{ opacity: this.props.isBanned ? 1 : 0.6 }}>
                <IconAttachmentFiles /> {this.props.materialCount}
              </Info>

              <Info style={{ opacity: this.props.isBanned ? 1 : 0.6 }}>
                {this.props.email}
              </Info>

              <Name>{this.props.name}</Name>
            </CardFooter>
          </BanWrapper>
        </ItemCard>
      </NavLink>
    );
  }
}

User.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  materialCount: PropTypes.number,
  avatar: PropTypes.string,
  isBanned: PropTypes.bool,
  email: PropTypes.string,
};

User.defaultProps = {
  name: 'Langke Zambo',
  materialCount: 10,
  email: '',
  avatar: '',
  isBanned: false,
};

export default withRouter(User);
